import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSelectedEventsDetails, getUserInfo } from "../store/auth/selectors";
import { CONFIG_VARS } from "../constants/configuration";

const CareerCounselingReport = () => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [reportReady, setReportReady] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(true);
  const userData = useSelector(getUserInfo);
  const examdetails = useSelector(getSelectedEventsDetails);
  useEffect(() => {
    if (examdetails) {
      const calculateTimeLeft = () => {
        // Parse the UTC time directly
        const submittedAtUTC = new Date(examdetails.submitedAt.replace(" ", "T") + "Z");

        // Just add 2 hours to it for report availability
        const reportAvailableAt = new Date(submittedAtUTC.getTime() + 2 * 60 * 60 * 1000);

        const now = new Date(); // This is in local time (IST if user's browser is IST)

        const difference = reportAvailableAt - now;
        if (difference <= 0) {
          setReportReady(true);
          return;
        }

        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
      };

      calculateTimeLeft();
      const timer = setInterval(calculateTimeLeft, 1000);
      return () => clearInterval(timer);
    }
  }, [examdetails]);

  const reportUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
    `${CONFIG_VARS.CC_reports_url}${userData.crn_id}/career_counselling_report.pdf`
  )}&embedded=true`;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "calc(100vh - 80px)",
        position: "relative"
      }}
    >
      {!reportReady ? (
        <div style={{ textAlign: "center" }}>
          <h2>We are preparing your report...</h2>
          {timeLeft && <p>Your report will be ready in: {timeLeft}</p>}
        </div>
      ) : (
        <>
          {iframeLoading && (
            <div
              style={{
                position: "absolute",
                zIndex: 10,
                background: "rgba(255,255,255,0.9)",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.5rem",
                fontWeight: "bold"
              }}
            >
              Loading report...
            </div>
          )}
          <iframe
            src={reportUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="Career Counseling Report"
            onLoad={() => setIframeLoading(false)}
          />
        </>
      )}
    </div>
  );
};

export default CareerCounselingReport;
